import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SharedModule } from './../SharedModule';
import { AppMainViewComponent } from './AppMainViewComponent';
import { ViewDisplayModule } from './Display/ViewDisplayModule';


//////////////////////////////////////////////////////////////////////////////
// このモジュールは、AppRoutingModule で設定が移譲されて、Appに読み込まれる。
//////////////////////////////////////////////////////////////////////////////
// ルーティング設定。ここで最初に表示されるViewを指定している。
const routes: Routes = [
	{ path: '',			component: AppMainViewComponent, }, // 基本となる画面
];

@NgModule({
	declarations: [
		AppMainViewComponent,
	], // ルーティングするComponent定義
	imports: [
		RouterModule.forChild(routes), // これで指定されているルーティング設定が作成される。
		SharedModule,
		ViewDisplayModule,
	],
	providers: [],
})
export class AppViewModule { }
